import React, { useState } from "react";
import { useAuth } from '../contextos/AuthProvider'
import '../CreaDocumento/TablaProductos.css';
import Modal from "react-modal";
import Swal from "sweetalert2";
import axios from 'axios';
import { EncApi, EncabezadoPost } from "../Comunes/Listas";
import { useNavigate } from 'react-router-dom';
import loading from '../New Template/images/loading.gif';
Modal.setAppElement('#root');

const TablaDocumentos = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [correoCopia, setcorreoCopia] = useState(0);
    const [LineasDocumentoDetalle, setLineasDocumentoDetalle] = useState([]);


    const openModal = (Documento, index) => {
        setSelectedDocument(Documento);

        ConsultarLineas(Documento.Ndoc, Documento.Consec);

        setcorreoCopia(Documento.PorcentajeDescuento);

        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setSelectedDocument(null);
    };

    const navigate = useNavigate();

    const GeneraDocumento = async (Doc, salida) => {

        const url = 'https://smartfecr.com:2017/api/Reportes/GeneraDocumento?NumDoc=' + selectedDocument.Ndoc + '&Doc=' + Doc + '&IdCia=' + PerfilUsuario.IdCia;
        console.log(url);
        Swal.fire({
            title: 'Favor de esperar',
            text: 'Se está procesando el documento...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (salida === 'DESCARGA') {
                const tempLink = document.createElement('a');
                tempLink.href = `data:application/pdf;base64,${data.Result}`;
                tempLink.setAttribute('download', 'Documento ' + selectedDocument.Ndoc + '.pdf');
                tempLink.click();
            }
            else {
              
                const blob = new Blob([Uint8Array.from(atob(data.Result), c => c.charCodeAt(0))], { type: "application/pdf" });
                const objectURL = URL.createObjectURL(blob);

                const iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = objectURL;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                };
                
                
                //imprimirRaspa(data.Result);
                  

            }


        } catch (error) {
            console.error("Error fetching document lines:", error);
        }
        finally {
            // Cerrar el swal automáticamente al finalizar (éxito o error)
            Swal.close();
        }
    }

   
    function imprimirRaspa(base64Pdf) {
    fetch("http://192.168.178.8:5000/print", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pdf: base64Pdf,
            printer: 'EPSON L3210 Series'
         })
    })
    .then(r => console.log("Impresión enviada"))
    .catch(e => console.error("Error al imprimir:", e));
}


    const generaXMLRpta = async (Doc) => {
        try {
            const url = `https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/descargarDoc?Consecutivo=${selectedDocument.Consec}&TipoDoc=${props.TipoDoc}&Doc=${Doc}&BDCompania=${PerfilUsuario.BD}`;
            //window.location.href = `https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/descargarDoc?Consecutivo=${selectedDocument.Consec}&TipoDoc=${props.TipoDoc}&Doc=${Doc}&BDCompania=${PerfilUsuario.BD}`;
            const response = await axios.get(url, EncApi(Token));

            // Extraer el contenido del archivo XML desde el JSON
            const fileContents = response.data.FileContents;
            const fileName = response.data.FileDownloadName;

            // Convertir el contenido Base64 a un Blob
            const byteCharacters = atob(fileContents);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/xml" });

            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            // Limpiar el enlace temporal
            document.body.removeChild(link);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al descargar el documento. Solo documentos aceptadps o rechazados son los que ya puede descargar. ' + error,
            });

        }
    };

    const ReEnvioCorreo = async () => {
        const url = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/ReEnvioCorreo';
        try {
            let Tabla = '';
            switch (props.TipoDoc) {
                case 'FAC': Tabla = 'Facturas'; break;
                case 'TIQ': Tabla = 'Facturas'; break;
                case 'EXP': Tabla = 'Facturas'; break;
                case 'NC': Tabla = 'NCs'; break;
                case 'ND': Tabla = 'NDs'; break;
                case 'COM': Tabla = 'Compras'; break;
                case 'FEC': Tabla = 'FECs'; break;
                case 'COT': Tabla = 'Cotizaciones'; break;
                case 'ORD': Tabla = 'Ordenes'; break;
                default: Tabla = 'Facturas'; break;
            }

            let GestorEnviar = {
                BDCia: PerfilUsuario.BD,
                Docnum: selectedDocument.Ndoc,
                Tabla: Tabla,
                ConCopia: correoCopia,
                Ambiente: PerfilUsuario.IdCia !== 1
            }
            await fetch(url, EncabezadoPost(Token, GestorEnviar)).then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.errors) {
                        let errorMessages = Object.values(json.errors).flat().join(', ');
                        Swal.fire({
                            icon: 'error',
                            title: 'Alerta...',
                            text: errorMessages,
                        });
                        return;
                    }
                    if (json.Codigo === 0) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Alerta...',
                            text: json.Mensaje
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Alerta...',
                            text: json.Mensaje
                        })
                    }
                })
        } catch (error) {
            console.error("Error fetching document lines:", error);
        }

    }

    const { PerfilUsuario, Token } = useAuth();
    const ConsultarLineas = async (idDoc, Consecu) => {
        const url = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/DetalleDocumento?TipoDoc=' + props.TipoDoc + '&NumDoc=' + idDoc + '&consecutivo=' + Consecu + '&Idcia=' + PerfilUsuario.IdCia;
        console.log(url);
        try {
            const response = await fetch(url, EncApi(Token));
            const data = await response.json();
            setLineasDocumentoDetalle(data);
        } catch (error) {
            console.error("Error fetching document lines:", error);
        }
    }
    const customStyles = {
        content: {
            top: '30%',
            left: '45%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#e7ecf0',
            borderTop: '#e09d00 solid 3px'
        },
    };

    const RedireccionarDocumentos = () => {

        switch (props.TipoDoc) {

            case 'NC':
                Swal.close();
                navigate("/Documentos/NDs");
                break;
            case 'FAC':
            case 'TIQ':
            case 'EXP':
            case 'ND':
                Swal.close();
                navigate("/Documentos/NCs");
                break;
            default:
                break;
        }
    }

    const handleSave = async (TipoDoc) => {
        Swal.fire({
            title: '¿Seguro en anular el documento?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Si, de acuerdo',
            denyButtonText: `No, Cancelar`,
        }).then(async (result) => {
            let TipoDocPar = '';
            console.log(TipoDoc);
            if (result.isConfirmed) {
                switch (TipoDoc) {
                    case 'FAC':
                        TipoDocPar = '1';
                        break;
                    case 'TIQ':
                        TipoDocPar = '4';
                        break;
                    case 'EXP':
                        TipoDocPar = '9';
                        break;
                    case 'NC':
                        TipoDocPar = '3';
                        break;
                    case 'ND':
                        TipoDocPar = '2';
                        break;
                    default:
                        Swal.fire({
                            icon: 'error',
                            title: 'Alerta...',
                            text: 'Este tipo de documento no se puede anular',
                        });
                        return;

                }
                let URL = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/OriflarDirecto?IdCia=' + PerfilUsuario.IdCia + '&TipoDoc=' + TipoDocPar + '&DocNum=' + selectedDocument.Ndoc;
                console.log(URL);
                await fetch(URL, EncApi(Token)
                ).then(response => response.json())
                    .then(json => {
                        if (json.errors) {
                            let errorMessages = Object.values(json.errors).flat().join(', ');
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: errorMessages,
                            });
                            return;
                        }
                        Swal.fire({
                            title: "Enviando...",
                            text: "Favor esperar mientras se guarda la información",
                            position: 'top-center',
                            imageUrl: loading,
                            backdrop: true,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                        if (json.CodRespuesta === 'Accepted' || json.Informacion === 'Alerta al generar token Unauthorized') {

                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Documento Guardado. Consecutivo: ' + json.Consecutivo,
                                showConfirmButton: true,
                                html: `
                                    <div>
                                        
                                        <button id="documentsButton" class="swal2-confirm swal2-styled" style="margin: 5px;">Ir a Documentos</button>
                                        
                                    </div>
                                `,
                                didOpen: () => {

                                    document.getElementById('documentsButton').addEventListener('click', RedireccionarDocumentos);
                                },
                                allowOutsideClick: true,
                                allowEscapeKey: true
                            });
                            //navigate("/Clientes/GeneralCliente");
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: json.Informacion
                            })
                        }
                    });
            }
        });



    };


    return (
        <div className="tabla-productos-container">
            <table className="tabla-productos">
                <thead>
                    <tr>
                        <th style={{ backgroundColor: "#007f5f" }}>#</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Código</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Nombre</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Fecha</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Consecutivo</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Monto</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Estado</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Correo</th>
                        <th style={{ backgroundColor: "#007f5f" }}>Opciones</th>
                    </tr>
                </thead>
                <tbody>
                    {props.DetalleDocs.map((doc, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{doc.Ndoc}</td>
                            <td>{doc.Nombre}</td>
                            <td>{doc.Fecha}</td>
                            <td>{doc.Consec}</td>
                            <td>{doc.Monto}</td>
                            <td style={{ backgroundColor: doc.EstadoHAC === 'Aceptado' ? '#B5EAD7' : doc.EstadoHAC === 'Aceptado-Nula' ? '#D5DBDB' : doc.EstadoHAC === 'Rechazado' ? '#D35400' : '#F4D03F' }} >{doc.EstadoHAC}</td>
                            <td>{doc.Correo}</td>
                            <td>
                                <button style={{ minWidth: '60px' }} onClick={() => openModal(doc, index)}>Opciones</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedDocument && (
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    size='sm'
                    className={'mymodalOpcionesDocumento'}
                    style={customStyles}
                >   <div className='tituloPantalla'>

                        <p style={{ display: 'inline-block', color: 'black' }}> {selectedDocument.Nombre + ' ' + selectedDocument.Monto + ' #' + selectedDocument.Ndoc}</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={closeModal} name="SalirHome"><i className="fa fa-times"></i></button>
                    </div>
                    <div style={{ marginLeft: '15px', marginTop: '5px', fontSize: '10px' }}>
                        <div className="row rowOpDoc" style={{ marginBottom: '10px' }}>
                            <div className="col-25" >
                                <button onClick={() => GeneraDocumento(props.TipoDoc, 'IMPRESO')}>Imprimir Carta</button>
                            </div>
                            <div className="col-25" >
                                <button onClick={() => GeneraDocumento(props.TipoDoc + '-PV', 'IMPRESO')}>Imprimir PV</button>
                            </div>
                            <div className="col-25" >
                                <button onClick={() => generaXMLRpta('Firmada')}>XML</button>
                            </div>
                            <div className="col-25" >
                                <button onClick={() => generaXMLRpta('Respuesta')}>XML Acuse</button>
                            </div>
                        </div>

                        <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-25" style={{ padding: '0px' }} >
                                <label>Actividad: </label>
                            </div>
                            <div className="col-75" >
                                <input
                                    type="text"
                                    disabled
                                    value={selectedDocument.Actividad}
                                    onChange={(e) => setcorreoCopia(e.target.value)}
                                />
                            </div>

                        </div>

                        <div className="row rowOpDoc" style={{ marginBottom: '10px' }}>
                            <div className="col-25" style={{ padding: '0px' }} >
                                <label>Reenviar por correo: </label>
                            </div>
                            <div className="col-50" >
                                <input
                                    type="text"
                                    value={correoCopia}
                                    onChange={(e) => setcorreoCopia(e.target.value)}
                                />
                            </div>
                            <div className="col-25" >
                                <button onClick={() => ReEnvioCorreo()}>Enviar</button>
                            </div>
                        </div>
                        <div className="row rowOpDoc" style={{ marginBottom: '10px' }}>


                            <textarea
                                value={selectedDocument.Nota}
                                onChange={(e) => setcorreoCopia(e.target.value)}
                                rows="5"
                                cols="3"
                                style={{ fontSize: "10px", padding: "10px", width: '95%', resize: "none" }}
                            />


                        </div>

                        <div className="row rowOpDoc">
                            <div className="col-25" >
                                <button onClick={() => GeneraDocumento(props.TipoDoc, 'DESCARGA')}>PDF Carta</button>

                            </div>
                            <div className="col-25" >
                                <button onClick={() => GeneraDocumento(props.TipoDoc + '-PV', 'DESCARGA')}>PDF PV</button>
                            </div>
                            <div className="col-25">
                                <button id="anularButton" onClick={() => handleSave(props.TipoDoc)}>Anular (NC)</button>
                            </div>

                            <div className="col-25">
                                <button onClick={closeModal}>Salir</button>
                            </div>
                            <div className="col-25">
                            </div>
                        </div>

                        <div className="tabla-productos-container" style={{ marginTop: '20px', width: '100%', marginBottom: '10px' }}>
                            <table className="tabla-productos">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#007f5f" }}>Código</th>
                                        <th style={{ backgroundColor: "#007f5f" }}>Detalle</th>
                                        <th style={{ backgroundColor: "#007f5f" }}>Precio Unitario</th>
                                        <th style={{ backgroundColor: "#007f5f" }}>Cantidad</th>
                                        <th style={{ backgroundColor: "#007f5f" }}>Tarifa</th>
                                        <th style={{ backgroundColor: "#007f5f" }}>Porcentaje Descuento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {LineasDocumentoDetalle.map((linea, index) => (
                                        <tr key={index}>
                                            <td>{linea.ItemCode}</td>
                                            <td>{linea.Detalle}</td>
                                            <td>{linea.PrecioUnitario.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            <td>{linea.Cantidad}</td>
                                            <td>{linea.Tarifa}</td>
                                            <td>{linea.PorcentajeDescuento}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default TablaDocumentos;